import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { Button, Panel, PanelGroup, Section } from '@lanl-web/lanl-components';

import LAROIcon from '../../assets/svg/LARO.inline.svg';
import EPRRIcon from '../../assets/svg/EPRR.inline.svg';
import SubjectGuidesIcon from '../../assets/svg/subject-guides.inline.svg';

import './StrategicPlan.scss';

export const StrategicPlan = ({ className }) => {
  const classes = classNames('strategic-plan-section', className);

  return (
    <Section backgroundColor='white' className={classes}>
      <PanelGroup divider className='value-panel'>
        <Panel
          link=''
          icon={<LAROIcon />}
          title='Mission'
          description='We deliver agile, responsive knowledge services, connecting people with information, technology, and resources'
        />
        <Panel
          link=''
          icon={<EPRRIcon />}
          title='Vision'
          description='Essential knowledge services for national security sciences'
        />
        <Panel
          link=''
          icon={<SubjectGuidesIcon />}
          title='Culture'
          description='We’re committed to leading Diversity, Equity, and Inclusion initiatives at LANL and within the library profession'
        />
      </PanelGroup>

      <div className='btn-box'>
        <Button arrow={false}>Strategic Plan</Button>
      </div>
    </Section>
  );
};

StrategicPlan.defaultProps = {};

StrategicPlan.propTypes = {
  className: PropTypes.string,
};

export default StrategicPlan;
